<template>
  <div class="d-main">
    <van-nav-bar
      id="titlebar"
      :title="userInfo?.websiteManage ? '统计' : '个人统计'"
      left-arrow
      @click-left="onClickLeft"
    >
    </van-nav-bar>
    <div v-if="userInfo?.websiteManage" class="content">
      <van-tabs v-model:active="active" border style="height: 100%">
        <van-tab title="网点统计" style="height: 100%; overflow: hidden">
          <siteView />
        </van-tab>
        <van-tab title="个人统计" style="height: 100%">
          <personView />
        </van-tab>
      </van-tabs>
    </div>
    <div v-else class="content">
      <personView />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import siteView from "./siteView.vue";
import personView from "./personView.vue";
import { userAuthStore } from "@/store/auth";

const common = userAuthStore();
const userInfo: any = ref(common.currUserData);
const active = ref(0);

const onClickLeft = () => {
  window?.flutter_inappwebview?.callHandler("goBackToApp", null);
};

onMounted(() => {});
</script>

<style scoped>
.d-main {
  width: 100%;
  height: calc(100% - 50px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #f6f6f6;
  font-size: 14px;
  overflow: hidden;
}

.content {
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background-color: #fff;
}

.sign {
  flex: 1;
  height: 60px;
  border-radius: 10px;
  background-color: #f2f3f5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 10px 15px;
  justify-content: center;
  color: #646566;
}
</style>
